<ng-template #contentHeaderTemplate>
  <div class="row" *appIfHasAllPermissions="[PERMISSION.QUALITYMANAGEMENT_PROCESS_CREATE_ALL]">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" routerLink="/quality-management/processes/add">
        {{ 'authenticated.quality-management.processes.create_btn' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<app-table
  routerLinkSuffix="/current"
  id="dashboard.quality-management.processes.index"
></app-table>
